import { writable } from 'svelte/store'
import runPromises from './runPromises'

/**
 * 
 * @param dataCalls: Object{}
 * @returns {Object[]}
 */
export default function (dataCalls) {
	const loading = writable(false)
	const error = writable(false)
	const data = writable({})
	
	async function get() {
		loading.set(true)
		error.set(false)

		try {
			const inboundData = await runPromises(dataCalls)
			data.set(inboundData)
		} catch(e) {
			error.set(e)
		}
		
		loading.set(false)
	}
	
	get()
	
	return [data, loading, error, get]
}